<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        @back="back"
        title
        :content="`Atendimento ${ruleForm.code} - ${ruleForm.customer.name}`"
      ></el-page-header>
    </el-card>
    <br />

    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('codigo')" prop="code" v-if="id">
              <el-input ref="code" disabled v-model="ruleForm.code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('Rota')" prop="route.description">
              <el-input
                disabled
                ref="description"
                v-model="ruleForm.route.description"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item :label="$t('rota-status')" prop="route.status">
              <el-input
                disabled
                ref="status"
                v-model="ruleForm.route.status"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('motorista')" prop="route.driver">
              <el-input
                disabled
                ref="driver"
                :value="ruleForm.route.driver ? ruleForm.route.driver.name : ''"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item :label="$t('cliente')" prop="customer">
              <el-input
                disabled
                ref="customer"
                v-model="ruleForm.customer.name"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="occurrencesWrapper">
        <h5>{{ $t("ocorrencias-relacionadas") }}</h5>

        <div class="occurrencesTable" v-if="ruleForm.occurrences.length > 0">
          <Occurrence
            :status="ruleForm.status"
            :collecteds="ruleForm.collecteds"
          />
        </div>

        <span v-if="ruleForm.occurrences.length == 0"
          >Nenhuma ocorrência registrada</span
        >
      </div>
    </el-card>
  </div>
</template>
<script>
import { AttendanceService } from "@/services/umov/attendance.services";
import Occurrence from "./components/Occurrence.vue";

import { i18n } from "@/plugin/i18n";

export default {
  name: "OccurenceAdd",
  components: {
    Occurrence,
  },
  data() {
    return {
      id: "",
      ruleForm: {
        code: "",
        route: "",
        status: "",
        occurrences: [],
        collecteds: [],
        customer: "",
        active: true,
      },
      isDisabled: false,
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.resetForm("ruleForm");
      vm.$router.push({ name: "attendance" });
    },

    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      AttendanceService.get(vm.id)
        .then((item) => {
          vm.ruleForm.code = item.code;
          vm.ruleForm.route = item.route;
          vm.ruleForm.status = item.status;
          vm.ruleForm.occurrences = item.occurrences;
          vm.ruleForm.collecteds = item.collecteds;
          vm.ruleForm.customer = item.customer;
          vm.ruleForm.active = true;

          switch (vm.ruleForm.route.status) {
            case "1":
              vm.ruleForm.route.status = "Pendente";
              break;

            case "2":
              vm.ruleForm.route.status = "Iniciada";
              break;

            case "3":
              vm.ruleForm.route.status = "Em Andamento";
              break;

            default:
              vm.ruleForm.route.status = "Finalizada";
              break;
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },

  mounted() {
    const vm = this;

    if (vm.$route.params.id) {
      vm.isDisabled = true;

      vm.id = vm.$route.params.id;

      vm.get();
    } else {
      vm.$refs.description.$el.children[0].focus();
      vm.ruleForm.action = "";
    }
  },
};
</script>
<style scoped lang="scss">
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}

.addActionOpt {
  color: red;
}

.el-dialog {
  width: 90% !important;
}

.el-dialog__wrapper {
  top: -50px;
}

.occurrencesWrapper {
  padding: 30px 0;

  h5 {
    margin-bottom: 30px;
  }
}
</style>
